import { render, staticRenderFns } from "./CollectionsChat.vue?vue&type=template&id=758be5c2"
import script from "./CollectionsChat.vue?vue&type=script&lang=js"
export * from "./CollectionsChat.vue?vue&type=script&lang=js"
import style0 from "./CollectionsChat.vue?vue&type=style&index=0&id=758be5c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports